const isMobile = window.innerWidth < 600;
export default isMobile;
